import { GtmDimensions, GtmEventNames } from 'google-tag-manager';
import { getTimeStamp, pushToDataLayer } from './utils/helpers';
import { pushGenericEventData } from './generic-event';

type AnalyticsPassengerMix = { adults: string | number; children: string | number; infants: string | number };
const buildGenericValue2 = (paxMix: AnalyticsPassengerMix) => `A: ${paxMix.adults}, C: ${paxMix.children}, I: ${paxMix.infants}`;

const baseEventParams = {
  eventCategory: 'Flight Grid',
  eventAction: 'confirm passengers modal',
  eventValue: null
};

export function fireConfirmPassengersImpressionEvent() {
  return pushGenericEventData({
    ...baseEventParams,
    eventLabel: 'confirm passenger modal impression',
    eventType: 'nonInteraction'
  });
}

export function fireConfirmPassengersValidationMessageEvent(validationMessage: { id: string; content: string }) {
  return pushToDataLayer({
    event: GtmEventNames.validationMessage,
    [GtmDimensions.timestamp]: getTimeStamp(),
    [GtmDimensions.validationMessageType]: 'Confirm Passenger Modal: Input Field Error',
    [GtmDimensions.validationMessageContent]: validationMessage.content,
    [GtmDimensions.validationMessageId]: validationMessage.id
  });
}

export function fireConfirmPassengersMixChangedEvent(paxMix: AnalyticsPassengerMix, element: 'direct input' | 'button input') {
  return pushGenericEventData(
    {
      ...baseEventParams,
      eventLabel: element === 'button input' ? 'plus or minus clicks' : 'picker modified',
      eventType: 'interaction'
    },
    {
      genericValue1: element,
      genericValue2: buildGenericValue2(paxMix)
    }
  );
}

export function fireConfirmPassengersApplyEvent(paxMix: AnalyticsPassengerMix) {
  return pushGenericEventData(
    {
      ...baseEventParams,
      eventLabel: 'confirm passenger modal button clicks',
      eventType: 'interaction'
    },
    {
      genericValue1: 'Apply',
      genericValue2: buildGenericValue2(paxMix)
    }
  );
}
